import { set } from "@/utils/vuex";

export default {
  resetState(state) {
    Object.assign(state, state.getDefaultState());
  },

  setLoading: set("loading"),
  // setSalesCSError: set('salesCSError'),
  setFilters: set("filters"),
  setItemsFilter: set("itemsFilter"),
  setTotalBillings: set("totalBillings"),
  setLoadingTotalBillings: set("loadingTotalBillings"),
  setBillings: set("billings"),
  setItems: set("items"),
  setItemsComplete: set("itemsComplete"),
  setLastItem: set("lastItem"),
  setLoadingBillings: set("loadingBillings"),
  setTotalBilling: set("totalBilling"),
  setDialogDetails: set("dialog_details"),
  setPagination: set("pagination"),
  setTotalItems: set("totalItems"),
  setBillingItems: set("billingItems"),
  setBillingFilters: set("billingFilters"),
  setBillingFilterPowerPlant(state, value) {
    // console.log('state1: ', state)
    // console.log('value1: ', value)
    state.billingFilters.power_plant_id = value;
  },
  setBillingFilterCompetence(state, value) {
    // console.log('state competence: ', state)
    // console.log('value competence: ', value)
    state.billingFilters.competence = value;
  },
  setBillingFilterStatus(state, value) {
    // console.log('state status: ', state)
    // console.log('value status: ', value)
    state.billingFilters.status = value;
  },
  setBankBatchs: set("bankBatchs"),
  setLoadingBankBatchs: set("loadingBankBatchs"),
  pushBankBatchs(state, value) {
    state.bankBatchs.push(value);
  },
  splitBankBatchs(state, data) {
    state.bankBatchs.splice(data.index, 1, data.data);
  },
  setBankBatchsUsinas: set("bankBatchsUsinas"),
  setLoadingBankBatchsUsinas: set("loadingBankBatchsUsinas"),
  pushBankBatchsUsinas(state, value) {
    state.bankBatchsUsinas.push(value);
  },
  splitBankBatchsUsinas(state, data) {
    state.bankBatchsUsinas.splice(data.index, 1, data.data);
  },
  setBilletsBankBatch: set("billetsBankBatch"),
  pushBilletsBankBatch(state, value) {
    state.billetsBankBatch.push(value);
  },
  splitBilletsBankBatch(state, data) {
    state.billetsBankBatch.splice(data.index, 1, data.data);
  },
};
